import { ENDPOINT } from "../../network/ENDPOINT";
import { callGetApiToServer, callApiToServer, putApiToServer, deleteApiToServer } from "../callApi";

function resolveAuthToken(explicitToken) {
  if (explicitToken) return explicitToken;
  try {
    const rawState = localStorage.getItem("state");
    if (rawState) {
      const parsed = JSON.parse(rawState);
      if (parsed && parsed.auth && parsed.auth.authToken) {
        return parsed.auth.authToken;
      }
    }
  } catch (_) {}
  return (
    localStorage.getItem("admin_token") ||
    localStorage.getItem("token") ||
    ""
  );
}

function createAuthHeader(authtoken) {
  const token = resolveAuthToken(authtoken);
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "Berear " + (token || ""),
  };
}

export async function fetchKhalesCategories(authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await callGetApiToServer(header, "GET", ENDPOINT.khales_categories);
  } catch (err) {
    throw err;
  }
}

export async function fetchKhalesVouchers(params = {}, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    const query = new URLSearchParams();
    if (params.category) query.append("category", params.category);
    if (params.search) query.append("search", params.search);
    const queryString = query.toString() ? `?${query.toString()}` : "";
    return await callGetApiToServer(header, "GET", `${ENDPOINT.khales_vouchers}${queryString}`);
  } catch (err) {
    throw err;
  }
}

export async function fetchKhalesVoucher(voucherId, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await callGetApiToServer(header, "GET", `${ENDPOINT.khales_voucher_detail}/${voucherId}`);
  } catch (err) {
    throw err;
  }
}

export async function fetchKhalesVariant(variantId, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await callGetApiToServer(header, "GET", `${ENDPOINT.khales_variant_detail}/${variantId}`);
  } catch (err) {
    throw err;
  }
}

export async function fetchKhalesBalance(authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await callGetApiToServer(header, "GET", ENDPOINT.khales_balance);
  } catch (err) {
    throw err;
  }
}

export async function fetchKhalesCardMapping(cardId, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await callGetApiToServer(header, "GET", `${ENDPOINT.khales_card_mapping}/${cardId}`);
  } catch (err) {
    throw err;
  }
}

export async function saveKhalesCardMapping(cardId, data, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    const body = JSON.stringify(data);
    return await putApiToServer(body, header, "PUT", `${ENDPOINT.khales_card_mapping}/${cardId}`);
  } catch (err) {
    throw err;
  }
}

export async function deleteKhalesCardMapping(cardId, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await deleteApiToServer(header, "DELETE", `${ENDPOINT.khales_card_mapping}/${cardId}`);
  } catch (err) {
    throw err;
  }
}

export async function fetchCardOrders(params = {}, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    const query = new URLSearchParams();
    if (params.status) query.append("status", params.status);
    if (params.userId) query.append("userId", params.userId);
    if (params.dateFrom) query.append("dateFrom", params.dateFrom);
    if (params.dateTo) query.append("dateTo", params.dateTo);
    if (params.page) query.append("page", params.page);
    if (params.limit) query.append("limit", params.limit);
    const queryString = query.toString() ? `?${query.toString()}` : "";
    return await callGetApiToServer(header, "GET", `${ENDPOINT.khales_card_orders}${queryString}`);
  } catch (err) {
    throw err;
  }
}

export async function fetchCardOrder(orderId, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    return await callGetApiToServer(header, "GET", `${ENDPOINT.khales_card_orders}/${orderId}`);
  } catch (err) {
    throw err;
  }
}

export async function recheckCardUnit(unitId, data = {}, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    const body = JSON.stringify(data);
    return await callApiToServer(body, header, "POST", `${ENDPOINT.khales_card_units_recheck}/${unitId}/recheck`);
  } catch (err) {
    throw err;
  }
}

export async function resolveCardUnit(unitId, data, authtoken) {
  try {
    const header = createAuthHeader(authtoken);
    const body = JSON.stringify(data);
    return await callApiToServer(body, header, "POST", `${ENDPOINT.khales_card_units_resolve}/${unitId}/resolve`);
  } catch (err) {
    throw err;
  }
}
